(() => {
  const createStatus = () => {
    let status = document.querySelector('[data-emb-cart-feedback]');
    if (status) return status;
    status = document.createElement('div');
    status.className = 'emb-cart-feedback';
    status.dataset.embCartFeedback = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.append(status);
    return status;
  };

  let hideTimer;
  let refreshTimer;
  let refreshController;

  const showStatus = (message, loading = false) => {
    const status = createStatus();
    window.clearTimeout(hideTimer);
    status.textContent = message;
    status.classList.toggle('is-loading', loading);
    status.classList.add('is-visible');
    if (!loading) {
      hideTimer = window.setTimeout(() => status.classList.remove('is-visible'), 2600);
    }
  };

  const refreshProgress = async () => {
    const current = document.querySelector('.emb-cart-progress[data-section-id]');
    const sectionId = current?.dataset.sectionId;
    if (!current || !sectionId) return;
    current.querySelector('[data-emb-cart-progress-panel]')?.setAttribute('aria-busy', 'true');
    refreshController?.abort();
    refreshController = new AbortController();
    try {
      const response = await fetch(`${window.routes.cart_url}?section_id=${encodeURIComponent(sectionId)}`, {
        cache: 'no-store',
        credentials: 'same-origin',
        signal: refreshController.signal,
      });
      if (!response.ok) throw new Error(`Cart progress request failed: ${response.status}`);
      const markup = await response.text();
      const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('.emb-cart-progress');
      if (next && current.isConnected) current.replaceWith(next);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('[Embrynium] Cart progress could not refresh.', error);
    } finally {
      document.querySelector('[data-emb-cart-progress-panel]')?.setAttribute('aria-busy', 'false');
    }
  };

  const handleCartUpdate = () => {
    showStatus('Updating your cart…', true);
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(async () => {
      await refreshProgress();
      showStatus('Cart updated');
    }, 120);
  };

  const init = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }
    document.addEventListener('embrynium:cart:updated', handleCartUpdate);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
